import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { educationService } from '@modules/staff/educationalDegree/services/educationService';
import useModal from '@shared/hooks/useModal';
import { useEditHandler } from '@shared/hooks/useEditHandler';
import { useDeleteHandler } from '@shared/hooks/useDeleteHandler';
import useFetchData from '@shared/hooks/useFetchData';

export const useEducationalDegree = () => {
    const { t } = useTranslation();
    const { modalState, handleOpenModal, handleCloseModal } = useModal();
    const [selectedDegree, setSelectedDegree] = useState(null);

    const {
        data,
        pageNumber,
        selectedData,
        setSelectedData,
        pageSize,
        searchQuery,
        searchType,
        sortBy,
        totalPages,
        totalElements,
        sortDir,
        setSearchQuery,
        setSearchType,
        handleSearchClick,
        fetchData,
        handleSort,
        setPageSize,
        setpageNumber
    } = useFetchData();

    const handleEditDegree = useEditHandler({
        data,
        selectedData,
        setSelectedItem: setSelectedDegree,
        handleOpenModal,
        errorMessage: 'No degree selected for editing'
    });

    useEffect(() => {
        fetchData(educationService.getDegrees, {
            searchQuery,
            sortBy: sortBy || 'code',
            sortDir
        });
    }, [pageNumber, pageSize, sortBy, sortDir]);

    const refreshData = () => fetchData(educationService.getDegrees, {
        searchQuery,
        pageNumber,
        pageSize,
        sortBy: sortBy || 'code',
        sortDir
    });

    const handleConfirmDelete = useDeleteHandler({
        service: educationService,
        entityName: 'Degree',
        selectedData,
        fetchData: async () => {
            try {
                // Reset to first page after deletion
                setpageNumber(0);
                // Fetch fresh data with current parameters
                await fetchData(educationService.getDegrees, {
                    searchQuery,
                    pageNumber: 0,
                    pageSize,
                    sortBy: 'code',
                    sortDir
                });
            } catch (error) {
                console.error('Error refreshing data after delete:', error);
            }
        },
        setSelectedData,
        handleCloseModal,
        successMessage: t('common.deletedSuccessfully'),
    });

    const searchOptions = [
        { key: 'education', label: 'education' },
        { key: 'degreeLevel', label: 'degree' }
    ];

    return {
        modalState,
        handleOpenModal,
        handleCloseModal,
        selectedDegree,
        setSelectedDegree,
        data,
        pageNumber,
        selectedData,
        setSelectedData,
        pageSize,
        searchQuery,
        searchType,
        sortBy,
        totalPages,
        totalElements,
        sortDir,
        setSearchQuery,
        setSearchType,
        handleSearchClick,
        fetchData,
        handleSort,
        setPageSize,
        setpageNumber,
        handleEditDegree,
        handleConfirmDelete,
        searchOptions,
        refreshData
    };
}; 